export const searchCompanies = (data, pageNo, pageSize) => ({apis}) => {
  let params = ''
  for (let key in data) {
    if (data[key]) {
      params += `&${key}=${data[key]}`
    }
  }
  params += `&page=${pageNo}&pageSize=${pageSize}`
  const payload = apis.searchCompanies(params).map((x) => x)
  return {
    type: 'SEARCH_DATA',
    payload,
  }
}

export const getSearchCriteria = (data) => ({apis}) => {
  const payload = apis.getSearchCriteria(data).map((x) => x)
  return {
    type: 'SEARCH_CRITERIA',
    payload,
  }
}

export const getAccessCountries = () => ({apis}) => {
  const payload = apis.getAccessCountries().map((x) => x)
  return {
    type: 'GET_COUNTRIES',
    payload,
  }
}

export const resetSearchParamsState = () => {
  return {
    type: 'RESET_SEARCH_PARAMS',
  }
}

export const onPageChange = (data) => {
  return {
    type: 'PAGE_CHANGE',
    data,
  }
}

export const selectedAccordionItem = (data) => {
  return {
    type: 'ACTIVE_ACCORDION_ITEM',
    data,
  }
}

export const clearSearchCriteria = () => {
  return {
    type: 'CLEAR_SEARCH_CRITERIA',
  }
}



// WEBPACK FOOTER //
// ./src/store/search/actions.js